import BackTop from './backTop'

// 注册全局组件
function plugins(Vue) {
  Vue.component("BackTop", BackTop)
}

export default plugins
